/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityKeyAIcon16Solid = forwardRef('SecurityKeyAIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 12a4.502 4.502 0 0 0 4.244-3H12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H8.744A4.502 4.502 0 0 0 0 7.5 4.5 4.5 0 0 0 4.5 12Zm0-2.748a1.752 1.752 0 1 0 0-3.504 1.752 1.752 0 0 0 0 3.504Z" })));
});
